<template>
  <div class="flex justify-center border-2 border-gray-200 rounded">
    <div>
      <div class="dropdown relative">
        <button
          class="dropdown-toggle px-6 py-2.5 font-thin text-xs text-gray-700 leading-tight uppercase rounded hover:bg-gray-200 focus:bg-gray-200 active:bg-gray-200 flex items-center whitespace-nowrap"
          @click="toggleDropdown()"
        >
          {{ sortLookup[currentSortValue] }}
          <i class="fas fa-chevron-down pl-2 text-gray-300" />
        </button>
        <ul
          v-if="showDropdown"
          class="dropdown-menu min-w-max absolute bg-white text-base z-50 float-left py-2 list-none text-left rounded-lg shadow-lg mt-1 m-0 bg-clip-padding border-none"
          aria-labelledby="dropdownMenuButton1"
        >
          <li v-for="(value, name, index) in sortLookup" :key="index">
            <a
              class="dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100"
              @click="setSortOption(name)"
            >
              {{ value }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { SortOrder } from '@/services/common/enums'

const sortLookup = {
  [SortOrder.TitleAZ]: 'Title A - Z',
  [SortOrder.TitleZA]: 'Title Z - A',
  [SortOrder.Newest]: 'Most Recent',
  [SortOrder.Oldest]: 'Less Recent',
}

export default {
  name: 'ListViewSort',
  setup() {
    const store = useStore()
    const route = useRoute()
    const showDropdown = ref(false)

    function toggleDropdown() {
      showDropdown.value = !showDropdown.value
    }
    const currentSortValue = computed(() => {
      const currentSearch = store.getters['Resources/currentRequest']
      return currentSearch.Sort
    })
    function setSortOption(sortOption) {
      store.dispatch('Resources/setSortOrder', sortOption)
      showDropdown.value = false
    }
    return { showDropdown, toggleDropdown, currentSortValue, sortLookup, setSortOption }
  },
}
</script>

<style scoped>

</style>
